export const iconFontAwesomeDesignRulerVertical = (
	<i className="fa-solid fa-ruler-vertical"></i>
);
